import { useLayoutEffect, useState } from 'react';

// Height that makes `ref`'s element reach the bottom of the window minus
// `bottomGap` px (so a loading table ends level with the left sidebar).
// Never below `minHeight`. Re-measured every frame while `active`.
const useFillToViewport = (ref, active, bottomGap = 34, minHeight = 260) => {
    const [height, setHeight] = useState(minHeight);
    useLayoutEffect(() => {
        if (!active) return undefined;
        let frame = null;
        const measure = () => {
            const top = ref.current?.getBoundingClientRect().top;
            if (top != null) {
                const next = Math.max(minHeight, Math.round(window.innerHeight - top - bottomGap));
                // Only re-render when it actually changed.
                setHeight((prev) => (Math.abs(prev - next) > 1 ? next : prev));
            }
            // Keep following the page while loading: cards above can still grow and the
            // page can scroll after the first measure (staff tab), pushing the table down.
            frame = requestAnimationFrame(measure);
        };
        measure();
        return () => cancelAnimationFrame(frame);
    }, [ref, active, bottomGap, minHeight]);
    return height;
};

export default useFillToViewport;
